@if (authService.actionSucceeded(parentComponent)) {
  <c-alert color="success" class="d-flex align-items-center" fade>
    <c-container
      class="confirmation-container"
      [style.direction]="authService.language.direction"
    >
      <c-row>
        <c-col class="text-bold">{{ message | translate }}</c-col>
      </c-row>
      @if (optionalText) {
        <c-row>
          <span [innerHTML]="optionalText | translate"></span>
        </c-row>
      }
    </c-container>
    <i [ngClass]="`${iconsStyle} ${iconSize} ${icons.checkCircle}`"></i>
  </c-alert>
}
